import { ClientError } from '@common/helpers/errors';

// The jobs.actions.patchPremiumFields BFF procedure was decommissioned along
// with je-client / je-job-service. This hook is retained as an inert stub so
// obsolete job-enhance UI still compiles; patching a job is no longer wired to
// a backend.
export type PatchJobParams = any;

export const usePatchPremiumFields = () => {
  const mutateAsync = (_params?: PatchJobParams): Promise<any> =>
    Promise.resolve(undefined);
  const isSuccess = false;
  const error = null as any;

  return {
    patchJobData: mutateAsync,
    isSuccess,
    error: getClientError(error)
  };
};

const getClientError = (error) => {
  if (!error?.message) return;

  return new ClientError('errors.defaultWithGuid', {
    guid: error?.properties?.guid,
    responseBody: error?.properties?.errorMessage
  });
};
